import { RangeSlider } from "@inputs/slider/RangeSlider";
import { Box, Stack } from "@mui/material";
import { type ReactNode, useId } from "react";

export interface IFilterLocationDistanceProps {
  label: ReactNode;
  distance: number;
  onChange: (distance: number) => void;
  icon?: ReactNode;
}

export const FilterLocationDistance = ({ label, distance, onChange, icon }: IFilterLocationDistanceProps) => {
  return (
    <Stack
      sx={{
        gap: 1,
      }}
    >
      <Stack sx={{ flexDirection: "row", alignItems: "center", gap: 1 }}>
        {icon && <Box sx={{ display: "inline", mr: 0.5 }}>{icon}</Box>}
        {label}
      </Stack>
      <RangeSlider
        id={useId()}
        size="small"
        leftLabelStyle={{ minWidth: 8 }}
        rightLabelStyle={{ minWidth: 8 }}
        SliderContainerProps={{ width: "50%" }}
        ContainerProps={{ sx: { py: 0, my: 0 } }}
        value={distance}
        onChange={(_, value) => onChange(Array.isArray(value) ? value[0] : value)}
        min={0}
        max={150}
        rightLabel={distance ? `à ${distance}km` : " "}
        leftLabel="Rayon de 0 km"
      />
    </Stack>
  );
};
